(() => {
  // Campi delle form Shopify → attributi dei moduli Brevo (liste #156 privati, #157 aziende)
  const BREVO_FIELDS = {
    'contact[email]': 'EMAIL',
    'contact[phone]': 'PHONE',
    'contact[Azienda]': 'COMPANY',
    'contact[Quantità indicativa]': 'QTA_INDICATIVA',
    'contact[body]': 'NOTE_RICHIESTA'
  };
  function brevoName(field) {
    if (BREVO_FIELDS[field]) return BREVO_FIELDS[field];
    const gusto = field.match(/^contact\[Quantità (.+)\]$/);
    if (gusto) return 'QTA_' + gusto[1].normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, '_');
    return null;
  }
  function sendToBrevo(form, url) {
    const data = new FormData();
    new FormData(form).forEach((value, field) => {
      if (field === 'contact[name]') {
        const parts = String(value).trim().split(/\s+/);
        data.append('FIRSTNAME', parts.shift() || '');
        data.append('LASTNAME', parts.join(' '));
        return;
      }
      const name = brevoName(field);
      if (!name || value === '') return;
      data.append(name, name === 'NOTE_RICHIESTA' ? String(value).slice(0, 500) : value);
    });
    data.append('email_address_check', '');
    data.append('locale', 'it');
    // keepalive: la richiesta parte anche se il submit Shopify cambia pagina subito dopo.
    // Brevo risponde 503 alle richieste no-cors: serve mode cors (il dominio è autorizzato da Brevo).
    try {
      fetch(url + (url.includes('?') ? '&' : '?') + 'isAjax=1', { method: 'POST', body: data, mode: 'cors', credentials: 'omit', keepalive: true }).catch(() => {});
    } catch (error) {}
  }
  function init(root = document) {
    root.querySelectorAll('[data-cn-request]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      const form = card.querySelector('form');
      const fields = form.querySelector('fieldset');
      const quantities = [...form.querySelectorAll('[data-quantity]')];
      const opensAt = Number(card.dataset.opensAt || 0);
      function openingState() {
        if (!opensAt) return;
        const open = Date.now() >= opensAt;
        fields.disabled = !open;
        card.querySelector('[data-opening-note]').textContent = open
          ? 'Le prenotazioni tramite modulo sono aperte.'
          : 'Il modulo per prenotare si apre il 18 ottobre 2026.';
      }
      function validateQuantities() {
        if (!quantities.length) return true;
        const selected = quantities.some(input => Number(input.value) > 0);
        quantities[0].setCustomValidity(selected ? '' : 'Indica la quantità di almeno un lievitato.');
        return selected;
      }
      quantities.forEach(input => input.addEventListener('input', validateQuantities));
      openingState();
      if (opensAt && Date.now() < opensAt) {
        const timer = setInterval(() => {
          openingState();
          if (Date.now() >= opensAt || !card.isConnected) clearInterval(timer);
        }, 30000);
      }
      const success = card.querySelector('[data-server-success]');
      if (success.dataset.serverSuccess === 'true' && location.hash === '#' + card.id) {
        success.hidden = false;
        fields.hidden = true;
      }
      form.addEventListener('submit', event => {
        if (opensAt && Date.now() < opensAt) {
          event.preventDefault();
          openingState();
          return;
        }
        if (!validateQuantities()) {
          event.preventDefault();
          quantities[0].reportValidity();
          return;
        }
        if (card.dataset.brevoUrl) sendToBrevo(form, card.dataset.brevoUrl);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
